<template>
    <div>
        <div v-if="socketConnected || (isInShop && status.length > 0)" class="cocons">
            <div v-for="status, cocon in cocons" :key="cocon" class="cocon" >
                <router-link :to="{name: 'cocons'}" class="router-link">
                    <span class="icon-connection" :class="{
                        'online' : isCoconConnected(cocon),
                        'offline' : !isCoconConnected(cocon),
                    }"></span>
                    <span class="progress" v-if="measurementActive(cocon)">
                        <span class="progress--circles">
                            <div class="progress--inner" :style="{width:measurementProgress(cocon)}"></div>
                        </span>
                        <span class="progress--label">
                            ({{measurementTime(cocon)}})
                        </span>
                    </span>
                    <span v-else>
                        <span
                            class="icon-status"
                            :class="{
                                'connected' : isOnline,
                                'disconnected' : !isOnline,
                            }"
                        ></span>
                    </span>
                    <span class="cocon-error" v-if="getLastError(cocon)">
                        {{getLastError(cocon)}}
                    </span>
                </router-link>
            </div>
        </div>
        <div v-else class="disconnect-error">
            <router-link :to="{name: 'cocons'}">
                <span class="icon-connection offline"></span>
            </router-link>
        </div>
        <!-- clippath -->
        <svg width="0" height="0">
            <defs>
                <clipPath id="coconClipPath">
                    <circle v-for="n in 13" :key="n"
                        :cx="8 + (n - 1) * 17"
                        :cy="10 + Math.sin(n*4) * 1.5"
                        r="7" />
                </clipPath>
            </defs>
        </svg>
    </div>
</template>

<script>
import LoginMixin from "@/mixins/LoginMixin";
import CoconMixin from "@/mixins/CoconMixin";
import OfflineMixin from "@/mixins/OfflineMixin";

export default {
    name : "CoconStatus",
    mixins : [LoginMixin, CoconMixin, OfflineMixin],

    props: {
        demoBedStatus: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        measurementProgress(cocon) {
            if (cocon < this.status.length) {
                return Math.round(this.status[cocon].progress) + "%";
            }
        },

        measurementTime(cocon) {
            if (cocon < this.status.length) {
                const data = this.status[cocon];
                if (!data.duration || !data.time) return "";

                const time = Math.round(data.duration - data.time);
                const mins = Math.floor(time / 60);
                const seconds = (time - mins * 60);

                return (mins < 10 ? "0" : "") + mins + ":" + (seconds < 10 ? "0" : "") + seconds;
            }
            return "";
        },

        measurementActive(cocon) {
            if (cocon < this.status.length) {
                return this.status[cocon].movie_active;
            }
            return false;
        },

        getLastError(cocon) {
            if (cocon < this.status.length && this.status[cocon].bed_errors !== undefined) {
                const coconErrors = this.status[cocon].bed_errors.filter(x => x.errorType.includes("E3"));
                if (coconErrors.length > 0) {
                    return coconErrors[coconErrors.length - 1].errorType;
                }
                return false;
            }
            return false;
        }
    }
};
</script>

<style lang="scss" scoped>
    .cocons {
        display: flex;
        flex-direction: row;
        width: 80vw;
        justify-content: flex-start;

        .cocon {
            margin-right : 2rem;
            width: 30%;
        }

        @include slideIntroAnimation(basicSlideIntro, 350ms, .8s);
    }

    .icon-connection {
        display : inline-block;
        width: 3.4rem;
        height: 2.5rem;
        background-repeat: no-repeat;
        background-size: 100%;

        &.offline {
            background-image : url('/img/icon-cocon-offline.png');
        }

        &.online {
            background-image : url('/img/icon-cocon-online.png');
        }
    }

    .icon-status {
        display : inline-block;
        width: 2.5rem;
        height: 2.5rem;
        background-repeat: no-repeat;
        background-size: 100%;
        margin-left: 0.5rem;

        &.connected {
            background-image : url('/img/icon-cocon-connected.png');
        }

        &.disconnected {
            background-image : url('/img/icon-cocon-disconnected.png');
        }
    }

    .progress {
        width : 100%;
        height : 100%;
        position: relative;
        display : flex;
        align-items: center;

        &--circles {
            position: relative;
            display : block;
            clip-path: url(#coconClipPath);
            background :#D7DBE0;
            width: 220px; //rem doesnt work properly with clippath
            height: 23px;
            margin : 0 .5rem;
        }

        &--inner {
            position: absolute;
            background : #404040;
            height : 100%;
            top : 0;
            left : 0;
        }
    }

    .disconnect-error {
        display: flex;
        align-items: center;
        color : $color-red;

        .icon-disconnect {
            width: 1.2rem;
            margin-left : .4rem;
        }
    }

    .router-link {
        display : flex;
        text-decoration: none;
    }

    .cocon-error {
        background: url('/img/cocon-error.svg') no-repeat;
        display: block;
        width: 2.5rem;
        height: 2.5rem;
        background-repeat: no-repeat;
        background-size: 100%;
        margin-left: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: .8rem;
    }
</style>